interface Role {
    value: string;
    label: string;
}

const roleOptions: Role[] = [
    { value: "PATIENT", label: "Patient" },
    { value: "CLINICIAN", label: "Clinician" },
    { value: "SECRETARY", label: "Secretary" },
];

const elevatedRoleOptions: Role[] = [
    { value: "VALIDATOR", label: "Validator" },
    { value: "ADMIN", label: "Admin" },
    { value: "MANAGER", label: "Manager" },
];

export function getInviteRoleOptions(includeElevatedRoles = false): Role[] {
    return includeElevatedRoles ? [...roleOptions, ...elevatedRoleOptions] : roleOptions;
}

export { roleOptions, elevatedRoleOptions };
